import { z } from 'zod';

export const OrgRoleSchema = z.enum(['owner', 'admin', 'member', 'viewer']);
export type OrgRole = z.infer<typeof OrgRoleSchema>;

export const OrgMemberSchema = z.object({
  userId: z.string(),
  email: z.string().email(),
  name: z.string().nullable(),
  role: OrgRoleSchema,
  joinedAt: z.string(),
  lastLogin: z.string().nullable(),
});
export type OrgMember = z.infer<typeof OrgMemberSchema>;

export const OrgSummarySchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  plan: z.string(),
  role: OrgRoleSchema,
});
export type OrgSummary = z.infer<typeof OrgSummarySchema>;

export const ListOrgMembersResponseSchema = z.object({
  members: z.array(OrgMemberSchema),
});
export type ListOrgMembersResponse = z.infer<typeof ListOrgMembersResponseSchema>;

export const InvitationSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  role: OrgRoleSchema,
  invitedBy: z.string().nullable(),
  invitedAt: z.string(),
  expiresAt: z.string(),
  status: z.enum(['pending', 'accepted', 'revoked', 'expired']),
});
export type Invitation = z.infer<typeof InvitationSchema>;

export const SendInviteRequestSchema = z.object({
  email: z.string().email(),
  role: OrgRoleSchema.default('member'),
});
export type SendInviteRequest = z.infer<typeof SendInviteRequestSchema>;
